import type { BookingCancellationReason, CalendarBlockDismissReason } from "@apartos/contracts";

export const cancellationReasonLabels: Record<BookingCancellationReason, string> = {
  moved: "Гость переселён в другой апартамент",
  duplicate: "Дубль брони",
  entry_error: "Ошибка оформления",
  guest_cancelled: "Гость отменил бронь",
  other: "Другое",
};

export const dismissReasonLabels: Record<CalendarBlockDismissReason, string> = {
  moved: "Гость переселён в другой апартамент",
  duplicate: "Дубль: гость уже оформлен",
  other: "Другое",
};

export function cancellationText(booking: { cancellationReason?: BookingCancellationReason; cancellationNote?: string }): string | undefined {
  if (!booking.cancellationReason && !booking.cancellationNote) return undefined;
  const label = booking.cancellationReason ? cancellationReasonLabels[booking.cancellationReason] : "Причина не указана";
  return booking.cancellationNote ? `${label}: ${booking.cancellationNote}` : label;
}
